module.exports = __webpack_public_path__ + "img/cross.2958bf7b.svg";